import { Divider } from '@heroui/react';
import styled from 'styled-components';

type DataGridProps = {
  elements?: number;
}

export const DataGridWrap = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
`;

export const DataGridBox = styled.div<DataGridProps>`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 33.33333%;
  margin-bottom: 24px;
`;

export const Label = styled.div`
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 4px;
  letter-spacing: -0.01em;
`;

export const Separator = styled(Divider)`
  margin-bottom: 24px;
  background: #CECECE;
`;

export const Content = styled.div`
  font-weight: 400;
  font-size: 24px;
  white-space: normal;
  margin: 0;
  width: 90%;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
`;
